module.exports = __webpack_public_path__ + "media/customizations/colton/back-bd9af6a1ecfaaf0f315ade762340922f.jpg";